var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PEC_lunBo1"},[_c('el-carousel',{attrs:{"interval":4000,"type":"card","height":this.height + 'em'}},_vm._l((_vm.realImgsUrls),function(item){return _c('el-carousel-item',{key:item},[_c('img',{attrs:{"src":item,"alt":"aa"}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }